import { breakpoints } from 'common/styles/theme/breakpoints';
import { colors } from 'common/styles/theme/colors';
import { shadows } from 'common/styles/theme/shadows';
import { typography } from 'common/styles/theme/typography';
import { utility } from 'common/styles/theme/utility';

export const theme = {
    breakpoints,
    colors,
    shadows,
    typography,
    utility,
};
